/*  MUI  */
import { Box, CircularProgress } from '@mui/material';
import { BroadcastChannelContext } from 'application/App/BroadcastChannelContext';

/*  Shared  */
import { Browser, Storage } from 'application/Shared/Handlers';

/*  Utils  */
import { Env, debug } from 'application/Shared/Utils';

/*  Objects  */
import Session from 'objects/Session';

/*  React  */
import React, { PureComponent } from 'react';
import { Navigate } from 'react-router';
import { withRouter } from 'router/withRouter';

/*  State  */
const state = () => ({
    loaded: false
});

class Logout extends PureComponent {
    // eslint-disable-next-line react/static-property-placement
    static contextType = BroadcastChannelContext;

    constructor(props) {
        super(props);
        this.state = state();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.cleanUp();
    }

    load = () => {
        Session.end(() => {
            this.context.sendMessage('pageReload');

            this.logoutSessionProvider();
        });
        Browser.handleTabTitle({});
    };

    cleanUp = () => {
        const { setSessionInfo } = this.props;
        setSessionInfo(null);
        this.setState({ loaded: true });
    };

    /**
     * Will logout a session provider such as Okta by calling their public logout apis.
     * @returns
     */
    logoutSessionProvider = async () => {
        let authType = null;
        let idToken = null;
        try {
            authType = await Storage.get('authentication-type');
        } catch (e) {
            // do nothing
        }

        Storage.remove('authentication-type');

        if (authType === 'google' || authType === 'microsoft') {
            this.cleanUp();
            return;
        }
        try {
            idToken = await Storage.get('okta_id_token');
            if (!idToken) {
                this.cleanUp();
                return;
            }
        } catch (e) {
            debug.e('okta id token is unavailable for session logout');
            this.cleanUp();
            return;
        }
        Storage.remove('okta_id_token');

        const url = `${Env.get(
            'REACT_APP_OKTA_ISSUER'
        )}/v1/logout?post_logout_redirect_uri=${window.location.protocol}//${
            window.location.host
        }/login&id_token_hint=${idToken}`;

        window.location.href = url;
    };

    render() {
        const { loaded } = this.state;
        if (!loaded) {
            return (
                <Box
                    height="100vh"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress />
                </Box>
            );
        }
        const { location } = this.props;

        const params = new URLSearchParams(location?.search);
        const forceLogout = params.get('forceLogout') === 'true';

        return (
            <Navigate
                to={{ pathname: '/login', search: location.search }}
                state={{ forceLogout }}
            />
        );
    }
}

export default withRouter(Logout);
